import React from "react"
import { useContext } from 'react';
import { LwpWidgetPropsContext } from './provider';

export default function useLwpWidgetProps() {
    const context = useContext(LwpWidgetPropsContext)

    if (!context) throw new Error('useLwpWidgetProps must be used within a LwpWidgetPropsProvider')

    return context
}
